var $18449f05cd88144d$exports = {};
$18449f05cd88144d$exports = {
    "endTime": `Pabaigos laikas`,
    "startTime": `Prad\u{17E}ios laikas`,
    "time": `Laikas`
};


export {$18449f05cd88144d$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
